export const IS_APP_PRODUCTION = import.meta.env.PROD;
export const IS_APP_DEVELOPMENT = import.meta.env.DEV;
